import React from "react";
import {
  Avatar,
  InputAdornment,
  TextField,
  Tooltip,
  Box,
  Typography,
  Chip,
  FormControl,
  InputLabel,
  Button,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import SyncDisabledIcon from "@mui/icons-material/SyncDisabled";
import DirectionsRunIcon from "@mui/icons-material/DirectionsRun";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { useSnackbar } from "notistack";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import SyncIcon from "@mui/icons-material/Sync";
import EditIcon from "@mui/icons-material/Edit";
import InfoIcon from "@mui/icons-material/Info";
import CloseIcon from "@mui/icons-material/Close";
import { s3baseUrl } from "src/config/config";
import CustomPopoverSection from "src/components/MenuOption/CustomPopoverSection";
import { Icon } from "@iconify/react";
import {
  exercise_history,
  exercise_obj,
  super_set_item,
  super_set_item_2,
  getMihrForPace,
  getKmhrForPace,
  getPaceTextinPaces,
} from "src/utils/constant";
import { useContentSetting } from "src/Hooks/ContentSettingState";
import { programme_workout_exercise_history_list_api } from "src/DAL/programmeWorkout/programmeWorkout";

const SuperSetUI = ({
  addArray,
  setExsrInfo,
  setModalOpen,
  setModalOpenForSuperset,
  setHistoryModalData,
  setSuperAlterIndex,
  setAlterChanges,
  setToAlterChanges,
  setOpenSuperSetAlter,
  setIsLoading,
  setDetailsData,
  setExerIndex,
  setOuterIndex,
  setIsWithHistory,
  setIsExerciseForSuperSet,
  setOpenSingleExerciseInfo,
  setSingleExerciseInfo,
  handleMouseLeave,
  setaddArray,
  setModalChangeExe,
  setHistoryModalOpenSuperset,
  data,
  mainindex,
  isHistory,
  isWithHistoryAndBigScreen,
  member_vdot,
  vdotwholeObject,
  memberId,
  setPaceModalOpen,
}) => {
  const {
    setUserExerciseHistory,
    setUserExerciseHistoryLoading,
    selectedExercise,
    setSelectedExercise,
  } = useContentSetting();

  const { enqueueSnackbar } = useSnackbar();

  const handleAdd = (i) => {
    let list = addArray;
    list.splice(i + 1, 0, {
      ...exercise_obj(member_vdot, vdotwholeObject),
    });
    setaddArray([...list]);
    setModalChangeExe(true);
    handleScrollCalled(i + 1);
  };

  const handleDeleteExer = (i) => {
    const delValue = [...addArray];
    delValue.splice(i, 1);
    setaddArray(delValue);
    setModalChangeExe(true);
  };

  const removeSuperSet = (mainIndex, index) => {
    const list = [...addArray];
    let firstPart = list[mainIndex]["superSet"].slice(0, index + 1);
    let secondPart = list[mainIndex]["superSet"].slice(index + 1);
    let firstObject = { ...firstPart[0] };
    if (index > 0) {
      firstObject.superSet = firstPart;
      firstObject.superset_sets = list[mainIndex].superset_sets;
    }

    let secondObject = { ...secondPart[0] };
    if (secondPart.length > 1) {
      secondObject.superSet = secondPart;
      secondObject.superset_sets = list[mainIndex].superset_sets;
    }

    let list1 = addArray;
    list1.splice(mainIndex + 1, 0, secondObject);
    list1.splice(mainIndex + 1, 0, firstObject);

    setaddArray([...list1]);
    setModalChangeExe(true);
    handleDeleteExer(mainIndex);
  };

  const handleAgreeSuperSet = (mainindex) => {
    setSuperAlterIndex(mainindex);

    setAlterChanges(
      addArray[mainindex + 1].superSet.length
        ? addArray[mainindex + 1].superset_sets
        : addArray[mainindex + 1].set.length,
    );

    setToAlterChanges(
      addArray[mainindex].superSet.length
        ? addArray[mainindex].superset_sets
        : addArray[mainindex].set.length,
    );

    const first = addArray[mainindex].superSet.length
      ? addArray[mainindex].superset_sets
      : addArray[mainindex].set.length;
    const second = addArray[mainindex + 1].superSet.length
      ? addArray[mainindex + 1].superset_sets
      : addArray[mainindex + 1].set.length;

    if (first == second) {
      addInSuperSet(mainindex);
    } else {
      setOpenSuperSetAlter(true);
    }
  };

  const addInSuperSet = (index) => {
    let array = addArray[index].superSet;
    if (addArray[index + 1].superSet.length > 0) {
      addArray[index + 1].superSet.map((item) => {
        array.push(item);
      });
    } else {
      array.push(addArray[index + 1]);
    }
    const list = [...addArray];
    list[index]["superSet"] = array;

    setaddArray(list);
    setModalChangeExe(true);
    let e = {
      target: {
        name: "superset_sets",
        value: list[index].superset_sets,
      },
    };
    handleChangeSuperSetCount(e, index);
    handleDelete(index + 1);
    setOpenSuperSetAlter(false);
  };

  const handleDelete = (i) => {
    const delValue = [...addArray];
    delValue.splice(i, 1);
    setaddArray(delValue);
    setModalChangeExe(true);
  };

  const handleArrowSuperSet = (value, mainindex, exerIndex) => {
    const list = [...addArray];
    list[mainindex]["superSet"][exerIndex]["open"] = value;
    setaddArray(list);
  };

  const handleChangeSuperSetDes = (e, index, index1) => {
    const { name, value } = e.target;
    const list = [...addArray];
    list[index]["superSet"][index1][name] = value;
    setaddArray(list);
    setModalChangeExe(true);
  };

  const handleChangeSuperSet = (e, mainindex, exerIndex, setIndex) => {
    const { name, value } = e.target;
    const list = [...addArray];
    list[mainindex]["superSet"][exerIndex]["set"][setIndex][name] = value;
    setaddArray(list);
    setModalChangeExe(true);
  };

  const handleChangeSuperSetTempo = (e, mainindex, exerIndex, setIndex) => {
    const { name, value } = e.target;
    if (value.length <= 4) {
      const list = [...addArray];
      list[mainindex]["superSet"][exerIndex]["set"][setIndex][name] = value;
      setaddArray(list);
      setModalChangeExe(true);
    }
  };

  const handleMinusSetCount = (index) => {
    const list = [...addArray];
    const name = "superset_sets";
    const value = parseInt(list[index].superset_sets) - 1;
    const targetValue = value === "" ? 1 : Math.max(1, parseInt(value, 10));
    list[index][name] = targetValue;
    list[index]?.superSet.forEach((superSetItem) => {
      const currentSetLength = superSetItem.set.length;
      if (currentSetLength < targetValue) {
        const objectsToAdd = targetValue - currentSetLength;
        for (let i = 0; i < objectsToAdd; i++) {
          superSetItem.set.push({
            ...super_set_item,
          });
        }
      } else if (currentSetLength > targetValue) {
        superSetItem.set.splice(targetValue);
      }
    });
    setaddArray(list);
    setModalChangeExe(true);
  };

  const handleAddSetCount = (index) => {
    const list = [...addArray];
    const name = "superset_sets";
    const value = parseInt(list[index].superset_sets) + 1;
    const targetValue = value === "" ? 1 : Math.max(1, parseInt(value, 10));
    list[index][name] = targetValue;
    list[index]?.superSet.forEach((superSetItem) => {
      const currentSetLength = superSetItem.set.length;
      if (currentSetLength < targetValue) {
        const objectsToAdd = targetValue - currentSetLength;
        const lastSet =
          currentSetLength > 0
            ? { ...superSetItem.set[currentSetLength - 1] }
            : { ...super_set_item_2 };
        for (let i = 0; i < objectsToAdd; i++) {
          superSetItem.set.push({ ...lastSet });
        }
      } else if (currentSetLength > targetValue) {
        superSetItem.set.splice(targetValue);
      }
    });
    setaddArray(list);
    setModalChangeExe(true);
  };

  const handleChangeSuperSetCount = (e, index) => {
    const { name, value } = e.target;
    const list = [...addArray];
    const targetValue = value === "" ? 1 : Math.max(1, parseInt(value, 10));
    list[index][name] = targetValue;
    list[index]?.superSet.forEach((superSetItem) => {
      const currentSetLength = superSetItem.set.length;

      if (currentSetLength < targetValue) {
        const objectsToAdd = targetValue - currentSetLength;

        for (let i = 0; i < objectsToAdd; i++) {
          superSetItem.set.push({
            ...super_set_item_2,
          });
        }
      } else if (currentSetLength > targetValue) {
        superSetItem.set.splice(targetValue);
      }
    });

    setaddArray(list);
    setModalChangeExe(true);
  };

  const handleChangeUp = (value) => {
    if (value == 0) {
      enqueueSnackbar("You are already on Top !", { variant: "info" });
      return;
    }
    const items = Array.from(addArray);
    const [reorderedItem] = items.splice(value, 1);
    items.splice(value - 1, 0, reorderedItem);
    setaddArray(items);
    setModalChangeExe(true);
  };

  const handleSupersetExerciseList = (mainIndex, exerInde, history) => {
    setDetailsData(mainIndex);
    setExerIndex(exerInde);
    setIsExerciseForSuperSet(true);
    setIsWithHistory(history);
  };

  const handleChangeDown = (value) => {
    if (value >= addArray.length - 1) {
      enqueueSnackbar("You are already on Bottom !", {
        variant: "info",
      });
      return;
    }
    const items = Array.from(addArray);
    const [reorderedItem] = items.splice(value, 1);
    items.splice(value + 1, 0, reorderedItem);

    setaddArray(items);
    setModalChangeExe(true);
  };

  const handleHistoryPreviousOpen = async (value) => {
    setSelectedExercise(value?.exercise?._id);
    setUserExerciseHistoryLoading(true);
    setUserExerciseHistory(value?.history);
    setUserExerciseHistoryLoading(false);
  };
  const handleClickOpen = async (exercise) => {
    setSingleExerciseInfo(exercise);
    setOpenSingleExerciseInfo(true);
  };

  const handleHistorySupersetOpen = async (value, mainIndex, exerInde) => {
    setDetailsData(mainIndex);
    setExerIndex(exerInde);
    handleHistorySuperset(value.exercise, mainIndex, exerInde);
  };

  const handleHistorySuperset = async (value, mainIndex, exerInde) => {
    setDetailsData(mainIndex);
    setExerIndex(exerInde);
    let postData = {
      exercise: value?._id,
      member: memberId,
    };
    setHistoryModalData([]);
    setIsLoading(true);
    try {
      let result = await programme_workout_exercise_history_list_api(postData);
      if (result.code == 200) {
        if (!result.exercise_history.length > 0) {
          const list = [...addArray];
          delete list[mainIndex]["superSet"][exerInde]["history"];
          setaddArray(list);
          return;
        }
        let givenExercise = result.exercise_history.map((item) => {
          return exercise_history(item);
        });

        setHistoryModalData(givenExercise);
        const list = [...addArray];
        list[mainIndex]["superSet"][exerInde]["history"] = givenExercise;
        setaddArray(list);
      } else {
        enqueueSnackbar(result.message, { variant: "error" });
      }
    } catch (error) {
    } finally {
      setIsLoading(false);
      setHistoryModalOpenSuperset(true);
    }
  };

  const handleParametersSuperset = (main, inr) => {
    setModalOpen(true);
    setModalOpenForSuperset(true);
    setOuterIndex(main);
    setExerIndex(inr);
    setExsrInfo(addArray[main].superSet[inr].parameters);
  };

  const memueOptions = (value) => {
    const MENU_OPTIONS = [];
    MENU_OPTIONS.unshift(
      {
        label: "Move Up",
        icon: "mdi:arrow-up",
        handleClick: handleChangeUp,
        disabled: value == 0 ? true : false,
      },
      {
        label: "Move Down",
        icon: "ic:outline-arrow-downward",
        handleClick: handleChangeDown,
        disabled: value >= addArray.length - 1 ? true : false,
      },
    );

    return MENU_OPTIONS;
  };

  const handleMinutesChangeSets = (e, mainindex, exerIndex, setIndex) => {
    const { name, value } = e.target;
    const list = [...addArray];
    const minutes = parseInt(e.target.value) || 0;
    const seconds =
      list[mainindex]["superSet"][exerIndex]["set"][setIndex][name] % 60;
    updateIntervalTimeSets(
      minutes,
      seconds,
      mainindex,
      exerIndex,
      setIndex,
      name,
    );
  };

  const handleSecondsChangeSets = (e, mainindex, exerIndex, setIndex) => {
    const { name, value } = e.target;
    const list = [...addArray];
    let seconds = parseInt(e.target.value) || 0;
    seconds = Math.min(Math.max(seconds, 0), 59);
    const minutes = Math.floor(
      list[mainindex]["superSet"][exerIndex]["set"][setIndex][name] / 60,
    );
    updateIntervalTimeSets(
      minutes,
      seconds,
      mainindex,
      exerIndex,
      setIndex,
      name,
    );
  };

  const updateIntervalTimeSets = (
    minutes,
    seconds,
    mainindex,
    exerIndex,
    setIndex,
    name,
  ) => {
    const totalSeconds = minutes * 60 + seconds;
    const list = [...addArray];
    list[mainindex]["superSet"][exerIndex]["set"][setIndex][name] =
      totalSeconds;
    setaddArray(list);
    setModalChangeExe(true);
  };

  const formatWithLeadingZeros = (value) => {
    return value < 10 ? `0${value}` : `${value}`;
  };

  const handleScrollCalled = (data) => {
    const todayCell = document.querySelector(
      `.exercise-label-box[id="${data}"]`,
    );
    if (todayCell)
      todayCell.scrollIntoView({ behavior: "smooth", block: "center" });
  };

  return (
    <div
      style={{ position: "relative" }}
      className="workout-Superset-card my-1"
    >
      <Box>
        <div className="d-flex align-items-start justify-content-between ">
          <div className="d-flex align-items-center w-100  mb-2">
            <div>Superset of</div>
            <div className="ms-2 cross-icon ">
              <RemoveCircleIcon
                onClick={() => handleMinusSetCount(mainindex)}
                className="diary-icon-plus-minus"
              />
            </div>
            <TextField
              id="outlined-basic"
              size="small"
              variant="outlined"
              placeholder="Sets"
              type="number"
              value={data?.superset_sets}
              name="superset_sets"
              disabled
              onChange={(e) => handleChangeSuperSetCount(e, mainindex)}
              InputLabelProps={{
                className: "textfiels-input-label",
                shrink: true,
                style: { fontSize: "14px" },
              }}
              InputProps={{
                className: "textfiels-input-value",
                style: { fontSize: "13px", padding: "0" },
              }}
              sx={{
                mx: 1,
                borderRadius: "5px",
                "& legend": { display: "none" },
                "& fieldset": { top: 0 },
                fontSize: "13px",
                "& input": {
                  padding: "3px 5px",
                  textAlign: "center",
                },
                width: "30px",
              }}
            />

            <div className=" cross-icon me-2">
              <AddCircleIcon
                onClick={() => handleAddSetCount(mainindex)}
                className="diary-icon-plus-minus"
              />
            </div>
            <div>sets</div>
          </div>
          <div className="cross-icon d-flex justify-content-end">
            <Tooltip title="Remove Exercise">
              <RemoveCircleOutlineIcon
                onClick={() => handleDelete(mainindex)}
                className="diary-icon-remove"
              />
            </Tooltip>
            <Tooltip title="Add Exercise">
              <AddCircleOutlineIcon
                onClick={() => handleAdd(mainindex)}
                className="diary-icon-add"
              />
            </Tooltip>
            <CustomPopoverSection
              menu={memueOptions(mainindex)}
              data={mainindex}
            />
          </div>
        </div>
        <div className=" mb-2 ">
          {data?.superSet?.map((exerData, exerIndex) => (
            <div
              style={{
                width: "100%",
                padding: "1px",
                position: "relative",
              }}
            >
              <div
                className="d-flex workout-set-card"
                style={{
                  width: "100%",
                  position: "relative",
                  overflow: "hidden",
                }}
              >
                <Box
                  sx={{
                    position: "relative",
                    width: "100%",
                  }}
                >
                  <div
                    className="row  "
                    onMouseEnter={() => handleMouseLeave()}
                  >
                    <div
                      className={`col-sm-12 ${
                        isHistory ? "col-md-6" : "col-md-7"
                      } col-lg-6 d-flex align-items-center p-0 mt-2 mt-md-0 mt-lg-0`}
                    >
                      {exerData?.is_modified && (
                        <span
                          style={{
                            position: "absolute",
                            top: "-11px",
                            justifyContent: "center",
                            zIndex: "1",
                            left: "-38px",
                            transform: "rotate(-53deg)",
                          }}
                        >
                          <Chip
                            label={"Modified"}
                            variant="contained"
                            color={"error"}
                            sx={{
                              fontSize: "10px",
                              height: "auto",
                              width: "auto",
                            }}
                          />
                        </span>
                      )}
                      <div className="exercise-label-box">
                        <span className="outer-label">Exercise</span>
                        <div className="d-flex align-items-center justify-content-between">
                          <div
                            className="exercise-label w-100"
                            onClick={() =>
                              handleSupersetExerciseList(
                                mainindex,
                                exerIndex,
                                exerData?.exercise ? true : false,
                              )
                            }
                          >
                            <div className="d-flex align-items-center">
                              {exerData?.exercise?.image?.thumbnail_3 && (
                                <Avatar
                                  sx={{ borderRadius: "5px" }}
                                  alt="User Image"
                                  src={
                                    s3baseUrl +
                                    exerData?.exercise?.image?.thumbnail_3
                                  }
                                />
                              )}
                              <div className="label-text ms-1">
                                {exerData?.exercise?.title
                                  ? exerData?.exercise?.title
                                  : ""}
                              </div>
                            </div>
                          </div>
                          <div className="exercise-action">
                            <div style={{ fontSize: "16px" }}>
                              {exerData?.exercise ? (
                                <div>
                                  <InfoIcon
                                    onClick={() =>
                                      handleClickOpen(exerData?.exercise?._id)
                                    }
                                    className="d-block"
                                    fontSize="14px"
                                    sx={{
                                      opacity: 0.5,
                                      cursor: "pointer",
                                    }}
                                  />
                                  <EditIcon
                                    onClick={() =>
                                      handleSupersetExerciseList(
                                        mainindex,
                                        exerIndex,
                                        true,
                                      )
                                    }
                                    fontSize="12px"
                                    sx={{
                                      opacity: 0.5,
                                      cursor: "pointer",
                                    }}
                                  />
                                </div>
                              ) : (
                                <AddIcon
                                  onClick={() =>
                                    handleSupersetExerciseList(
                                      mainindex,
                                      exerIndex,
                                    )
                                  }
                                  sx={{
                                    opacity: 0.5,
                                    cursor: "pointer",
                                  }}
                                />
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <Button
                        sx={{ textTransform: "inherit" }}
                        size="small"
                        color="primary"
                        variant="contained"
                        className="d-flex align-items-center ms-2 small-contained-dialog-button"
                        onClick={() => {
                          handleArrowSuperSet(
                            !exerData?.open ? true : false,
                            mainindex,
                            exerIndex,
                          );
                        }}
                      >
                        {!exerData?.open ? (
                          <KeyboardArrowDownIcon
                            sx={{
                              cursor: "pointer",
                              fontSize: "20px",
                            }}
                          />
                        ) : (
                          <KeyboardArrowUpIcon
                            sx={{
                              cursor: "pointer",
                              fontSize: "20px",
                            }}
                          />
                        )}
                        <Typography
                          variant="body2"
                          sx={{
                            whiteSpace: "nowrap",
                          }}
                        >
                          {` Sets ${exerData?.set?.length}`}
                        </Typography>
                      </Button>
                    </div>

                    <div
                      className={`col-sm-12 ${
                        isHistory ? "col-md-6" : "col-md-5"
                      } col-lg-6 p-0 mt-2 mt-md-0 mt-lg-0 d-flex align-items-center justify-content-start `}
                    >
                      <div className="d-flex align-items-center mx-1">
                        <div
                          className="d-flex align-items-center ms-3 set-parameters "
                          onClick={() => {
                            handleParametersSuperset(mainindex, exerIndex);
                          }}
                        >
                          <Icon icon="pajamas:labels" fontSize="10px" />
                          <Typography variant="body2" sx={{ ml: 0.5 }}>
                            {`Parameters`}
                          </Typography>
                        </div>
                        {!isWithHistoryAndBigScreen &&
                        isHistory &&
                        exerData?.exercise ? (
                          <>
                            <Button
                              sx={{ textTransform: "inherit" }}
                              size="small"
                              color="primary"
                              variant="contained"
                              className="d-flex align-items-center ms-2 small-contained-dialog-button"
                              onClick={() => {
                                handleHistorySupersetOpen(
                                  exerData,
                                  mainindex,
                                  exerIndex,
                                );
                              }}
                            >
                              <Icon icon="fa-solid:history" fontSize="10px" />
                              <Typography variant="body2" sx={{ ml: 0.5 }}>
                                {`History`}
                              </Typography>
                            </Button>
                            {member_vdot && (
                              <Button
                                sx={{ textTransform: "inherit" }}
                                size="small"
                                color="primary"
                                variant="contained"
                                className="d-flex align-items-center ms-2 small-contained-dialog-button"
                                onClick={() => setPaceModalOpen(true)}
                              >
                                <DirectionsRunIcon sx={{ fontSize: "14px" }} />
                                <Typography variant="body2" sx={{ ml: 0.5 }}>
                                  Pace
                                </Typography>
                              </Button>
                            )}
                          </>
                        ) : isWithHistoryAndBigScreen &&
                          exerData?.history &&
                          selectedExercise != exerData?.exercise?._id ? (
                          <Button
                            sx={{ textTransform: "inherit" }}
                            size="small"
                            color="primary"
                            variant="contained"
                            className="d-flex align-items-center ms-2 small-contained-dialog-button"
                            onClick={() => {
                              handleHistoryPreviousOpen(exerData);
                            }}
                          >
                            <Icon icon="fa-solid:history" fontSize="10px" />
                            <Typography variant="body2" sx={{ ml: 0.5 }}>
                              {`History`}
                            </Typography>
                          </Button>
                        ) : (
                          isHistory &&
                          exerData?.history && (
                            <Button
                              sx={{ textTransform: "inherit" }}
                              size="small"
                              color="primary"
                              variant="outlined"
                            >
                              <Icon icon="fa-solid:history" fontSize="10px" />
                              <Typography variant="body2" sx={{ ml: 0.5 }}>
                                Viewing History
                              </Typography>
                            </Button>
                          )
                        )}
                      </div>
                    </div>
                  </div>
                  {exerData?.open && (
                    <TextField
                      id="outlined-basic"
                      size="small"
                      variant="outlined"
                      placeholder="Instructions"
                      label="Instructions"
                      type="number"
                      value={exerData.description}
                      name="description"
                      multiline
                      rows={2}
                      onChange={(e) =>
                        handleChangeSuperSetDes(e, mainindex, exerIndex)
                      }
                      InputLabelProps={{
                        className: "textfiels-input-label",
                        shrink: true,
                        style: { fontSize: "14px" },
                      }}
                      InputProps={{
                        className: "textfiels-input-value",
                        style: { fontSize: "14px" },
                      }}
                      sx={{
                        borderRadius: "5px",
                        mt: 2,
                        width: "100%",
                      }}
                    />
                  )}
                  {exerData?.open &&
                    exerData?.set?.map((item, setIndex) => (
                      <div className="d-flex align-items-center my-3 workout-card-inset">
                        <div className="d-flex align-items-center w-100">
                          <Typography
                            variant="body1"
                            sx={{
                              padding: "25px 4px",
                              color: "inherit",
                              backgroundColor: "#edeff1",
                              height: "100%",
                              width: "15px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              borderRadius: "7px",
                            }}
                          >
                            {setIndex + 1}
                          </Typography>
                          <CloseIcon sx={{ opacity: 0.3 }} />
                          <div className="row w-100">
                            {(exerData.parameters.includes("Pace") ||
                              exerData.parameters.includes("Vdot")) && (
                              <>
                                <div
                                  className={
                                    isWithHistoryAndBigScreen
                                      ? "col-3 pe-0 py-2"
                                      : `col-12 col-md-3 col-lg-2 pe-0 py-2`
                                  }
                                >
                                  <FormControl fullWidth>
                                    <InputLabel
                                      className="set-Type-lable"
                                      sx={{
                                        fontSize: "14px",
                                      }}
                                      id="demo-simple-select-label"
                                    >
                                      Type
                                    </InputLabel>
                                    <Select
                                      id="select-option"
                                      variant="outlined"
                                      size="small"
                                      name="race_type"
                                      value={item?.race_type}
                                      label="Type"
                                      inputProps={{
                                        style: {
                                          padding: 0,
                                        },
                                      }}
                                      onChange={(e) => {
                                        handleChangeSuperSet(
                                          e,
                                          mainindex,
                                          exerIndex,
                                          setIndex,
                                        );
                                      }}
                                      sx={{
                                        width: "100%",
                                        fontSize: "13px",
                                        "& .MuiOutlinedInput-input": {
                                          paddingLeft: 1,
                                        },
                                      }}
                                    >
                                      <MenuItem value="el">Easy/Long</MenuItem>
                                      <MenuItem value="c">Compromised</MenuItem>
                                      <MenuItem value="i">Interval</MenuItem>
                                      <MenuItem value="r">Repitition</MenuItem>
                                    </Select>
                                  </FormControl>
                                </div>
                                <div
                                  className={
                                    isWithHistoryAndBigScreen
                                      ? "col-3 pe-0 py-2"
                                      : `col-12 col-md-3 col-lg-2 pe-0 py-2`
                                  }
                                >
                                  <TextField
                                    sx={{
                                      borderRadius: "5px",
                                      paddingRight: 0,
                                      width: "100%",
                                    }}
                                    size="small"
                                    id="custom-input"
                                    variant="outlined"
                                    placeholder={"Distance"}
                                    name="distance"
                                    label="Distance"
                                    value={item?.distance}
                                    onChange={(e) => {
                                      handleChangeSuperSet(
                                        e,
                                        mainindex,
                                        exerIndex,
                                        setIndex,
                                      );
                                    }}
                                    type="number"
                                    InputLabelProps={{
                                      className: "textfiels-input-label",
                                      shrink: true,
                                      style: {
                                        fontSize: "14px",
                                      },
                                    }}
                                    InputProps={{
                                      className: "textfiels-input-value",
                                      style: {
                                        fontSize: "13px",
                                        paddingRight: 0,
                                      },
                                      endAdornment: (
                                        <InputAdornment position="end">
                                          <Select
                                            id="select-option"
                                            variant="outlined"
                                            size="small"
                                            name="distanceType"
                                            value={item?.distanceType}
                                            label="Weight Type"
                                            onChange={(e) => {
                                              handleChangeSuperSet(
                                                e,
                                                mainindex,
                                                exerIndex,
                                                setIndex,
                                              );
                                            }}
                                            sx={{
                                              "& legend": {
                                                display: "none",
                                              },
                                              "& fieldset": {
                                                top: 0,
                                              },
                                              fontSize: "13px",
                                              border: "none",
                                              "& fieldset": {
                                                border: "none",
                                              },
                                            }}
                                          >
                                            <MenuItem value="m">Meter</MenuItem>
                                            <MenuItem value="km">KM</MenuItem>
                                            <MenuItem value="mi">Mile</MenuItem>
                                          </Select>
                                        </InputAdornment>
                                      ),
                                    }}
                                  />
                                </div>
                                <div
                                  className={
                                    isWithHistoryAndBigScreen
                                      ? "col-3 pe-0 py-2"
                                      : `col-12 col-md-2 col-lg-2 pe-0 py-2`
                                  }
                                >
                                  <TextField
                                    id="outlined-basic"
                                    variant="outlined"
                                    label={getPaceTextinPaces(
                                      item?.distanceType,
                                    )}
                                    InputLabelProps={{
                                      className: "textfiels-input-label",
                                      shrink: true,
                                      style: {
                                        fontSize: "14px",
                                      },
                                    }}
                                    InputProps={{
                                      className: "textfiels-input-value",
                                      style: {
                                        fontSize: "13px",
                                        paddingLeft: "0px",
                                        paddingRight: "0px",

                                        justifyContent: "center",
                                      },
                                      readOnly: true,
                                      endAdornment: (
                                        <InputAdornment
                                          position="end"
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                          }}
                                        >
                                          <TextField
                                            id="outlined-basic-minutes"
                                            type="number"
                                            size="small"
                                            placeholder="Min"
                                            name="pace"
                                            value={formatWithLeadingZeros(
                                              Math.floor(item?.pace / 60),
                                            )}
                                            onChange={(e) =>
                                              handleMinutesChangeSets(
                                                e,
                                                mainindex,
                                                exerIndex,
                                                setIndex,
                                              )
                                            }
                                            InputProps={{
                                              className:
                                                "textfiels-input-value",
                                              style: {
                                                fontSize: "14px",
                                              },
                                            }}
                                            sx={{
                                              "& fieldset": {
                                                border: "none",
                                              },
                                              "& input": {
                                                textAlign: "center",
                                                padding: "0px",
                                              },
                                              width: "100%",
                                            }}
                                          />
                                          <div className="fs-6 fw-semibold ms-1 ">
                                            :
                                          </div>
                                          <TextField
                                            id="outlined-basic-seconds"
                                            type="number"
                                            size="small"
                                            placeholder="Sec"
                                            name="pace"
                                            value={formatWithLeadingZeros(
                                              item?.pace % 60,
                                            )}
                                            onChange={(e) =>
                                              handleSecondsChangeSets(
                                                e,
                                                mainindex,
                                                exerIndex,
                                                setIndex,
                                              )
                                            }
                                            InputProps={{
                                              className:
                                                "textfiels-input-value",
                                              style: {
                                                fontSize: "14px",
                                              },
                                            }}
                                            sx={{
                                              "& fieldset": {
                                                border: "none",
                                              },
                                              "& input": {
                                                textAlign: "center",
                                                padding: "0px",
                                              },
                                              width: "100%",
                                            }}
                                          />
                                        </InputAdornment>
                                      ),
                                    }}
                                    sx={{
                                      borderRadius: "5px",
                                      fontSize: "13px",
                                      "& .css-e9crry-MuiInputBase-input-MuiOutlinedInput-input":
                                        {
                                          width: "0px !important",
                                          padding: "9px 0px !important",
                                        },
                                      "& .css-1nuss9t": {
                                        width: "0px !important",
                                        padding: "9px 0px !important",
                                      },
                                      width: "100%",
                                    }}
                                  />
                                </div>
                                <div
                                  style={{
                                    position: "absolute",
                                    bottom: "4px",
                                    left: "5px",
                                  }}
                                >
                                  <Typography
                                    variant="subtitle2"
                                    sx={{
                                      opacity: 0.6,
                                      fontWeight: "600",
                                      fontSize: "12px",
                                    }}
                                  >{` @ Speed ${getKmhrForPace(
                                    item?.distance,
                                    item?.pace,
                                    item?.distanceType,
                                  )} km/hr or ${getMihrForPace(
                                    item?.distance,
                                    item?.pace,
                                    item?.distanceType,
                                  )} mi/hr`}</Typography>
                                </div>
                              </>
                            )}
                            {(exerData.parameters.includes("Duration/Pace") ||
                              exerData.parameters.includes("Time")) && (
                              <div
                                className={
                                  isWithHistoryAndBigScreen
                                    ? "col-3 pe-0 py-2"
                                    : `col-12 col-md-3 col-lg-2 pe-0 py-2`
                                }
                              >
                                <TextField
                                  id="outlined-basic"
                                  size="small"
                                  variant="outlined"
                                  placeholder="0"
                                  type="number"
                                  value={item?.time}
                                  name="time"
                                  onChange={(e) => {
                                    handleChangeSuperSet(
                                      e,
                                      mainindex,
                                      exerIndex,
                                      setIndex,
                                    );
                                  }}
                                  InputLabelProps={{
                                    className: "textfiels-input-label",
                                    shrink: true,
                                    style: {
                                      fontSize: "14px",
                                    },
                                  }}
                                  label={
                                    exerData.parameters.includes(
                                      "Duration/Pace",
                                    )
                                      ? "Duration/Pace"
                                      : "Time"
                                  }
                                  InputProps={{
                                    className: "textfiels-input-value",
                                    style: {
                                      fontSize: "13px",
                                      paddingRight: 0,
                                    },
                                    endAdornment: (
                                      <InputAdornment position="end">
                                        <Select
                                          id="select-option"
                                          variant="outlined"
                                          size="small"
                                          name="timeType"
                                          value={item?.timeType}
                                          label="Weight Type"
                                          inputProps={{
                                            style: {
                                              padding: 0,
                                            },
                                          }}
                                          onChange={(e) => {
                                            handleChangeSuperSet(
                                              e,
                                              mainindex,
                                              exerIndex,
                                              setIndex,
                                            );
                                          }}
                                          sx={{
                                            "& legend": {
                                              display: "none",
                                            },
                                            "& fieldset": {
                                              top: 0,
                                            },
                                            fontSize: "13px",
                                            border: "none",
                                            "& fieldset": {
                                              border: "none",
                                            },
                                            "& .MuiOutlinedInput-input": {
                                              padding: 0,
                                            },
                                          }}
                                        >
                                          <MenuItem value="sec">sec</MenuItem>
                                          <MenuItem value="min">min</MenuItem>
                                        </Select>
                                      </InputAdornment>
                                    ),
                                  }}
                                  sx={{
                                    borderRadius: "5px",
                                    fontSize: "13px",
                                    width: "100%",
                                  }}
                                />
                              </div>
                            )}
                            {exerData.parameters.includes("Reps") && (
                              <div
                                className={
                                  isWithHistoryAndBigScreen
                                    ? "col-2 pe-0 py-2"
                                    : "col-12 col-md-2 col-lg-1 pe-0 py-2"
                                }
                              >
                                <TextField
                                  id="outlined-basic"
                                  size="small"
                                  variant="outlined"
                                  placeholder="Reps"
                                  type="text"
                                  label="Reps"
                                  value={item?.reps}
                                  name="reps"
                                  onChange={(e) => {
                                    handleChangeSuperSet(
                                      e,
                                      mainindex,
                                      exerIndex,
                                      setIndex,
                                    );
                                  }}
                                  InputLabelProps={{
                                    className: "textfiels-input-label",
                                    shrink: true,
                                    style: {
                                      fontSize: "14px",
                                    },
                                  }}
                                  InputProps={{
                                    className: "textfiels-input-value",
                                    style: {
                                      fontSize: "13px",
                                    },
                                  }}
                                  sx={{
                                    borderRadius: "5px",
                                    fontSize: "13px",
                                    width: "100%",
                                  }}
                                />
                              </div>
                            )}
                            {exerData.parameters.includes("Max_Reps") && (
                              <div
                                className={
                                  isWithHistoryAndBigScreen
                                    ? "col-2 pe-0 py-2"
                                    : "col-12 col-md-2 col-lg-1 pe-0 py-2"
                                }
                              >
                                <TextField
                                  id="outlined-basic"
                                  size="small"
                                  variant="outlined"
                                  placeholder="Max Reps"
                                  type="number"
                                  label="Max Reps"
                                  value={item?.maxReps}
                                  name="maxReps"
                                  onChange={(e) => {
                                    handleChangeSuperSet(
                                      e,
                                      mainindex,
                                      exerIndex,
                                      setIndex,
                                    );
                                  }}
                                  InputLabelProps={{
                                    className: "textfiels-input-label",
                                    shrink: true,
                                    style: {
                                      fontSize: "14px",
                                    },
                                  }}
                                  InputProps={{
                                    className: "textfiels-input-value",
                                    style: {
                                      fontSize: "13px",
                                    },
                                  }}
                                  sx={{
                                    borderRadius: "5px",
                                    fontSize: "13px",
                                    width: "100%",
                                  }}
                                />
                              </div>
                            )}
                            {exerData.parameters.includes("Watts") && (
                              <div
                                className={
                                  isWithHistoryAndBigScreen
                                    ? "col-2 pe-0 py-2"
                                    : "col-12 col-md-2 col-lg-1 pe-0 py-2"
                                }
                              >
                                <TextField
                                  id="outlined-basic"
                                  size="small"
                                  variant="outlined"
                                  placeholder="Watts"
                                  type="number"
                                  label="Watts"
                                  value={item?.watts}
                                  name="watts"
                                  onChange={(e) => {
                                    handleChangeSuperSet(
                                      e,
                                      mainindex,
                                      exerIndex,
                                      setIndex,
                                    );
                                  }}
                                  InputLabelProps={{
                                    className: "textfiels-input-label",
                                    shrink: true,
                                    style: {
                                      fontSize: "14px",
                                    },
                                  }}
                                  InputProps={{
                                    className: "textfiels-input-value",
                                    style: {
                                      fontSize: "13px",
                                    },
                                  }}
                                  sx={{
                                    borderRadius: "5px",
                                    fontSize: "13px",
                                    width: "100%",
                                  }}
                                />
                              </div>
                            )}
                            {exerData.parameters.includes("Height") && (
                              <div
                                className={
                                  isWithHistoryAndBigScreen
                                    ? "col-3 pe-0 py-2"
                                    : "col-12 col-md-3 col-lg-2 pe-0 py-2"
                                }
                              >
                                <TextField
                                  id="outlined-basic"
                                  size="small"
                                  variant="outlined"
                                  placeholder="0"
                                  type="number"
                                  value={item?.height}
                                  name="height"
                                  onChange={(e) => {
                                    handleChangeSuperSet(
                                      e,
                                      mainindex,
                                      exerIndex,
                                      setIndex,
                                    );
                                  }}
                                  InputLabelProps={{
                                    className: "textfiels-input-label",
                                    shrink: true,
                                    style: {
                                      fontSize: "14px",
                                    },
                                  }}
                                  label="Height"
                                  InputProps={{
                                    className: "textfiels-input-value",
                                    style: {
                                      fontSize: "13px",
                                      paddingRight: 0,
                                    },
                                    endAdornment: (
                                      <InputAdornment position="end">
                                        <Select
                                          id="select-option"
                                          variant="outlined"
                                          size="small"
                                          name="height_unit"
                                          value={item?.height_unit}
                                          label="Height Type"
                                          inputProps={{
                                            style: {
                                              padding: 0,
                                            },
                                          }}
                                          onChange={(e) => {
                                            handleChangeSuperSet(
                                              e,
                                              mainindex,
                                              exerIndex,
                                              setIndex,
                                            );
                                          }}
                                          sx={{
                                            "& legend": {
                                              display: "none",
                                            },
                                            "& fieldset": {
                                              top: 0,
                                            },
                                            fontSize: "13px",
                                            border: "none",
                                            "& fieldset": {
                                              border: "none",
                                            },
                                            "& .MuiOutlinedInput-input": {
                                              padding: 0,
                                            },
                                          }}
                                        >
                                          <MenuItem value="cm">Cm</MenuItem>
                                          <MenuItem value="ft">Feet</MenuItem>
                                          <MenuItem value="inch">Inch</MenuItem>
                                        </Select>
                                      </InputAdornment>
                                    ),
                                  }}
                                  sx={{
                                    borderRadius: "5px",
                                    fontSize: "13px",
                                    width: "100%",
                                  }}
                                />
                              </div>
                            )}
                            {exerData.parameters.includes("Weight") && (
                              <div
                                className={
                                  isWithHistoryAndBigScreen
                                    ? "col-3 pe-0 py-2"
                                    : "col-12 col-md-4 col-lg-2 pe-0 py-2"
                                }
                              >
                                <TextField
                                  sx={{
                                    borderRadius: "5px",
                                    paddingRight: 0,
                                    width: "100%",
                                  }}
                                  size="small"
                                  id="custom-input"
                                  variant="outlined"
                                  placeholder="Weight"
                                  name="weight"
                                  label="Weight"
                                  value={item.weight}
                                  onChange={(e) => {
                                    handleChangeSuperSet(
                                      e,
                                      mainindex,
                                      exerIndex,
                                      setIndex,
                                    );
                                  }}
                                  type="number"
                                  InputLabelProps={{
                                    className: "textfiels-input-label",
                                    shrink: true,
                                    style: {
                                      fontSize: "14px",
                                    },
                                  }}
                                  InputProps={{
                                    className: "textfiels-input-value",
                                    style: {
                                      fontSize: "13px",
                                      paddingRight: 0,
                                    },
                                    endAdornment: (
                                      <InputAdornment position="end">
                                        <Select
                                          id="select-option"
                                          variant="outlined"
                                          size="small"
                                          name="weightType"
                                          value={item?.weightType}
                                          label="Weight Type"
                                          onChange={(e) => {
                                            handleChangeSuperSet(
                                              e,
                                              mainindex,
                                              exerIndex,
                                              setIndex,
                                            );
                                          }}
                                          sx={{
                                            "& legend": {
                                              display: "none",
                                            },
                                            "& fieldset": {
                                              top: 0,
                                            },
                                            fontSize: "13px",
                                            border: "none",
                                            "& fieldset": {
                                              border: "none",
                                            },
                                            "& .MuiOutlinedInput-input": {
                                              padding: 0,
                                            },
                                          }}
                                        >
                                          <MenuItem value="1rm">% 1RM</MenuItem>
                                          <MenuItem value="body_weight">
                                            % BW
                                          </MenuItem>
                                          <MenuItem value="kg">KG</MenuItem>
                                          <MenuItem value="lb">Pound</MenuItem>
                                          <MenuItem value="poods">
                                            Poods
                                          </MenuItem>
                                        </Select>
                                      </InputAdornment>
                                    ),
                                  }}
                                />
                              </div>
                            )}
                            {exerData.parameters.includes(
                              "Distance/Calories",
                            ) && (
                              <div
                                className={
                                  isWithHistoryAndBigScreen
                                    ? "col-3 pe-0 py-2"
                                    : "col-12 col-md-3 col-lg-2 pe-0 py-2"
                                }
                              >
                                <TextField
                                  sx={{
                                    borderRadius: "5px",
                                    paddingRight: 0,
                                    width: "100%",
                                  }}
                                  size="small"
                                  id="custom-input"
                                  variant="outlined"
                                  placeholder={
                                    item?.distanceType == "calories"
                                      ? "Calories"
                                      : "Distance"
                                  }
                                  name="distance"
                                  label="Distance/Calories"
                                  value={item?.distance}
                                  onChange={(e) => {
                                    handleChangeSuperSet(
                                      e,
                                      mainindex,
                                      exerIndex,
                                      setIndex,
                                    );
                                  }}
                                  type="number"
                                  InputLabelProps={{
                                    className: "textfiels-input-label",
                                    shrink: true,
                                    style: {
                                      fontSize: "14px",
                                    },
                                  }}
                                  InputProps={{
                                    className: "textfiels-input-value",
                                    style: {
                                      fontSize: "13px",
                                      paddingRight: 0,
                                    },
                                    endAdornment: (
                                      <InputAdornment position="end">
                                        <Select
                                          id="select-option"
                                          variant="outlined"
                                          size="small"
                                          name="distanceType"
                                          value={item?.distanceType}
                                          label="Weight Type"
                                          onChange={(e) => {
                                            handleChangeSuperSet(
                                              e,
                                              mainindex,
                                              exerIndex,
                                              setIndex,
                                            );
                                          }}
                                          sx={{
                                            "& legend": {
                                              display: "none",
                                            },
                                            "& fieldset": {
                                              top: 0,
                                            },
                                            fontSize: "13px",
                                            border: "none",
                                            "& fieldset": {
                                              border: "none",
                                            },
                                            "& .MuiOutlinedInput-input": {
                                              padding: 0,
                                            },
                                          }}
                                        >
                                          <MenuItem value="m">Meter</MenuItem>
                                          <MenuItem value="km">KM</MenuItem>
                                          <MenuItem value="mi">Mile</MenuItem>
                                          <MenuItem value="calories">
                                            Calories
                                          </MenuItem>
                                        </Select>
                                      </InputAdornment>
                                    ),
                                  }}
                                />
                              </div>
                            )}
                            {exerData.parameters.includes("%MHR") && (
                              <div
                                className={
                                  isWithHistoryAndBigScreen
                                    ? "col-2 pe-0 py-2"
                                    : "col-12 col-md-2 col-lg-1 pe-0 py-2"
                                }
                              >
                                <TextField
                                  id="outlined-basic"
                                  size="small"
                                  variant="outlined"
                                  placeholder="%MHR"
                                  type="number"
                                  label="%MHR"
                                  value={item?.mhr}
                                  name="mhr"
                                  onChange={(e) => {
                                    handleChangeSuperSetTempo(
                                      e,
                                      mainindex,
                                      exerIndex,
                                      setIndex,
                                    );
                                  }}
                                  InputLabelProps={{
                                    className: "textfiels-input-label",
                                    shrink: true,
                                    style: {
                                      fontSize: "14px",
                                    },
                                  }}
                                  InputProps={{
                                    className: "textfiels-input-value",
                                    style: {
                                      fontSize: "13px",
                                    },
                                  }}
                                  sx={{
                                    borderRadius: "5px",
                                    fontSize: "13px",
                                    width: "100%",
                                    "& .MuiOutlinedInput-input": {
                                      padding: "8px 7px",
                                    },
                                  }}
                                />
                              </div>
                            )}{" "}
                            {exerData.parameters.includes("RPE") && (
                              <div
                                className={
                                  isWithHistoryAndBigScreen
                                    ? "col-2 pe-0 py-2"
                                    : "col-12 col-md-2 col-lg-1 pe-0 py-2"
                                }
                              >
                                <TextField
                                  id="outlined-basic"
                                  size="small"
                                  variant="outlined"
                                  placeholder="RPE"
                                  label="RPE"
                                  value={item?.RPE}
                                  name="RPE"
                                  onChange={(e) => {
                                    handleChangeSuperSet(
                                      e,
                                      mainindex,
                                      exerIndex,
                                      setIndex,
                                    );
                                  }}
                                  InputLabelProps={{
                                    className: "textfiels-input-label",
                                    shrink: true,
                                    style: {
                                      fontSize: "14px",
                                    },
                                  }}
                                  InputProps={{
                                    className: "textfiels-input-value",
                                    style: {
                                      fontSize: "13px",
                                    },
                                  }}
                                  sx={{
                                    borderRadius: "5px",
                                    fontSize: "13px",
                                    width: "100%",
                                    "& .MuiOutlinedInput-input": {
                                      padding: "8px 7px",
                                    },
                                  }}
                                />
                              </div>
                            )}
                            {exerData.parameters.includes("Tempo") && (
                              <div
                                className={
                                  isWithHistoryAndBigScreen
                                    ? "col-2 pe-0 py-2"
                                    : "col-12 col-md-2 col-lg-1 pe-0 py-2"
                                }
                              >
                                <TextField
                                  id="outlined-basic"
                                  size="small"
                                  variant="outlined"
                                  placeholder="Tempo"
                                  type="number"
                                  label="Tempo"
                                  value={item?.tempo}
                                  name="tempo"
                                  onChange={(e) => {
                                    handleChangeSuperSetTempo(
                                      e,
                                      mainindex,
                                      exerIndex,
                                      setIndex,
                                    );
                                  }}
                                  InputLabelProps={{
                                    className: "textfiels-input-label",
                                    shrink: true,
                                    style: {
                                      fontSize: "14px",
                                    },
                                  }}
                                  InputProps={{
                                    className: "textfiels-input-value",
                                    style: {
                                      fontSize: "13px",
                                    },
                                  }}
                                  sx={{
                                    borderRadius: "5px",

                                    fontSize: "13px",
                                    width: "100%",
                                    "& .MuiOutlinedInput-input": {
                                      padding: "8px 7px",
                                    },
                                  }}
                                />
                              </div>
                            )}
                            {exerData.parameters.includes("Rest") && (
                              <div
                                className={
                                  isWithHistoryAndBigScreen
                                    ? "col-3 pe-0 py-2"
                                    : "col-12 col-md-3 col-lg-2 pe-0 py-2"
                                }
                              >
                                <TextField
                                  id="outlined-basic"
                                  size="small"
                                  variant="outlined"
                                  placeholder="0"
                                  type="number"
                                  value={item?.rest}
                                  name="rest"
                                  onChange={(e) => {
                                    handleChangeSuperSet(
                                      e,
                                      mainindex,
                                      exerIndex,
                                      setIndex,
                                    );
                                  }}
                                  InputLabelProps={{
                                    className: "textfiels-input-label",
                                    shrink: true,
                                    style: {
                                      fontSize: "14px",
                                    },
                                  }}
                                  label="Rest"
                                  InputProps={{
                                    className: "textfiels-input-value",
                                    style: {
                                      fontSize: "13px",
                                      paddingRight: 0,
                                    },
                                    endAdornment: (
                                      <InputAdornment position="end">
                                        <Select
                                          id="select-option"
                                          variant="outlined"
                                          size="small"
                                          name="restType"
                                          value={item?.restType}
                                          label="Weight Type"
                                          inputProps={{
                                            style: {
                                              padding: 0,
                                            },
                                          }}
                                          onChange={(e) => {
                                            handleChangeSuperSet(
                                              e,
                                              mainindex,
                                              exerIndex,
                                              setIndex,
                                            );
                                          }}
                                          sx={{
                                            "& legend": {
                                              display: "none",
                                            },
                                            "& fieldset": {
                                              top: 0,
                                            },
                                            fontSize: "13px",
                                            border: "none",
                                            "& fieldset": {
                                              border: "none",
                                            },
                                            "& .MuiOutlinedInput-input": {
                                              padding: 0,
                                            },
                                          }}
                                        >
                                          <MenuItem value="sec">sec</MenuItem>
                                          <MenuItem value="min">min</MenuItem>
                                        </Select>
                                      </InputAdornment>
                                    ),
                                  }}
                                  sx={{
                                    borderRadius: "5px",
                                    fontSize: "13px",
                                    width: "100%",
                                  }}
                                />
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    ))}
                  {exerData?.open && (
                    <div className="row mt-3 d-flex justify-content-center">
                      <div className="col-md-2 col-lg-1 col-3">
                        <button
                          onClick={(e) => {
                            e.preventDefault();
                            handleArrowSuperSet(false, mainindex, exerIndex);
                          }}
                          className="w-100 small-contained-set-button"
                        >
                          <KeyboardArrowUpIcon
                            sx={{
                              cursor: "pointer",
                              opacity: 0.5,
                              fontSize: "20px",
                            }}
                            onClick={() => {
                              handleArrowSuperSet(false, mainindex, exerIndex);
                            }}
                          />
                        </button>
                      </div>
                    </div>
                  )}
                </Box>
              </div>
              <span
                className="cross-icon"
                style={{
                  position: "absolute",
                  bottom: "-10px",
                  display: "flex",
                  width: "100%",
                  justifyContent: "center",
                  zIndex: 1,
                }}
              >
                {data?.superSet.length > 1 &&
                exerIndex < data?.superSet.length - 1 ? (
                  <div className="">
                    <SyncDisabledIcon
                      onClick={() => removeSuperSet(mainindex, exerIndex)}
                      className="sync-icon-remove"
                    />
                  </div>
                ) : (
                  ""
                )}
              </span>
            </div>
          ))}
        </div>
      </Box>
      <span
        className="cross-icon"
        style={{
          position: "absolute",
          bottom: "-17px",
          width: "100%",
          display: "flex",
          justifyContent: "center",
          zIndex: 1,
        }}
      >
        {addArray.length > 1 &&
        mainindex < addArray.length - 1 &&
        addArray[mainindex + 1]?.type == "general" ? (
          <div className="">
            <SyncIcon
              onClick={() => handleAgreeSuperSet(mainindex)}
              className="sync-icon-add"
            />
          </div>
        ) : (
          ""
        )}
      </span>
    </div>
  );
};

export default SuperSetUI;
